import React from 'react'
import './utils'
import { ChakraProvider, createStandaloneToast } from "@chakra-ui/react"
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux';
import { AppStore, persistor } from './redux'
import { AlertProvider, AuthProvider } from './services'
import { HelmetProvider } from 'react-helmet-async';
import {theme} from './theme'
import Routes from './routes'
import { BrowserRouter as Router } from 'react-router-dom';
// import { createStandaloneToast } from '@chakra-ui/toast'

const { ToastContainer } = createStandaloneToast()

const App = () => {    
 
    return (
        <Provider store={AppStore}>
            <PersistGate loading={null} persistor={persistor}>
                <ChakraProvider theme={theme}>  
                    <ToastContainer />  
                    <HelmetProvider>
                        <AlertProvider>
                            <AuthProvider>   
                                <Router>
                                    <Routes />                                                              
                                </Router>
                            </AuthProvider>          
                        </AlertProvider>
                    </HelmetProvider>
                </ChakraProvider>
            </PersistGate>
        </Provider>
      )
}

export default App
